import type { ReactNode } from 'react';

import { AppHead } from '@components/AppHead';
import { useClientEnvironment } from '@hooks/clientEnvironment';
import { useAuth } from '@lib/auth';
import { SplashScreen } from '@views/SplashScreen';

import LoginIndex from './login';

// TODO
// add user from redux to use for conditional render
type Props = {
  children: ReactNode;
  routeProtected: boolean;
};

const defaultClientName = process.env.NEXT_PUBLIC_CLIENT_NAME;

const ProtectRoute = ({ children, routeProtected }: Props): JSX.Element => {
  const { isAuthenticated, loading: isAuthLoading } = useAuth();
  const { data: clientEnvironment, isLoading: isClientEnvironmentLoading } = useClientEnvironment();

  if (isAuthLoading || isClientEnvironmentLoading)
  return (
    <>
      <AppHead clientEnvironment={clientEnvironment} defaultClientName={defaultClientName} />
      <SplashScreen />
    </>
  );

  return (
    <>
      <AppHead clientEnvironment={clientEnvironment} defaultClientName={defaultClientName} />
      {!isAuthenticated && routeProtected ? <LoginIndex /> : children}
    </>
  );
};

export default ProtectRoute;
